<template>
  <WdsTooltip global :z-index="zIndex" placement="top" :text="explanation">
    <WdsText data-test="client-payment-terms-label" class="tw-inline-block tw-max-w-[200px] tw-truncate">
      {{ label ?? '—' }}
    </WdsText>
  </WdsTooltip>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText, WdsTooltip } from '@worksome/wds-components'
import { PaymentTermMethod } from '@/gql/graphql'
import { $t, $tc } from '@/app-bootstrapping/SetUpInternationalization'

const props = defineProps<{
  days: number | null
  method: PaymentTermMethod | null
  followsClient: boolean
  /** Pass a z-index inside fixed containers; WdsTooltip mispositions itself there otherwise. */
  zIndex?: number
}>()

const methodLabels: Record<PaymentTermMethod, string> = {
  [PaymentTermMethod.Net]: $t('net'),
  [PaymentTermMethod.EndOfMonth]: $t('end of month'),
}

const label = computed(() =>
  props.days === null || props.method === null
    ? null
    : `${$tc(':count day | :count days', props.days)} ${methodLabels[props.method]}`,
)

const explanation = computed(() =>
  props.followsClient
    ? $t("The client's payment terms: your hires for this client are contracted on them.")
    : $t("Your own payment terms: hires for this client do not follow the client's."),
)
</script>
